import { render } from "./footer.vue?vue&type=template&id=0b95e490&scoped=true"
const script = {}

import "./footer.vue?vue&type=style&index=0&id=0b95e490&scoped=true&lang=css"

import exportComponent from "D:\\project\\ncc-projectlib\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b95e490"]])

export default __exports__